@if (isSelected()) {
  <input-wrap class="visually-hidden">
  <input type="checkbox"
    [(ngModel)]="valid"
    name="{{name}}"
    required />
</input-wrap>
}

<div class="is-required w-12"
  [ngClass]="{'m-t m-b': hostedFieldsInstance,  'no' : threeDSInProgress, 'braintree-submitted': submitted}">

  <div class="braintree-input-container w-12 flex-column flex-top"
    [ngClass]="{'no' : !hostedFieldsInstance}">
    <label class="c1 p-l-1 p-r-1 left-2 bg-col-5 col-4 label input-wrap-label"
    [attr.for]="'card-number-' + componentId">{{'Card Number' | translate}}</label>
    <div class="input w-12"
    [attr.id]="'card-number-' + componentId"></div>
    <div class="flex flex-column c2 flex-top  p-t-1">
      <span class="col-2 braintree-input__empty validation-error">
      {{'Card number is required.' | translate}}</span>
      <span class="col-2 braintree-input__error validation-error">
      {{'This field is not valid.' | translate}}</span>
    </div>
  </div>
  <div class="flex flex-row w-12 m-t-6">
    <div class="braintree-input-container w-6 flex flex-column flex-top p-r-3"
      [ngClass]="{'no' : !hostedFieldsInstance || !hasVerification()}">
      <label class="c1 p-l-1 p-r-1 left-2 bg-col-5 col-4 label input-wrap-label"
      [attr.for]="'cvv-' + componentId">CVV</label>
      <div [ngClass]="{'input w-12-s' : hostedFieldsInstance && hasVerification()}"
      [attr.id]="'cvv-' + componentId"></div>
      <div class="flex flex-column c2 flex-top p-t-1">
        <span class="col-2 braintree-input__empty validation-error">{{'Cvv is required.' | translate}}</span>
        <span class="col-2 braintree-input__error validation-error">
        {{'This field is not valid.' | translate}}</span>
      </div>
    </div>
    <div class="braintree-input-container w-6 flex flex-column flex-top"
      [ngClass]="{'no' : !hostedFieldsInstance}">
      <label class="c1 p-l-1 p-r-1 left-2 bg-col-5 col-4 label input-wrap-label"
      [attr.for]="'expiration-date-' + componentId">{{'Expiration Date' | translate}}</label>
      <div class="input w-12-s"
      [attr.id]="'expiration-date-' + componentId"></div>
      <div class="flex flex-column c2 flex-top p-t-1">
        <span class="col-2 braintree-input__empty validation-error">
        {{'Expiration date is required.' | translate}}</span>
        <span class="col-2 braintree-input__error validation-error">
        {{'This field is not valid.' | translate}}</span>
      </div>
    </div>
  </div>

  @if (hostedFieldsInstance && useSaveCard()) {
    <div class="m-t-6 m-b-2 col-12 address-fieldset"
      >
      <checkbox name="save_card"
        (ngModelChange)="detectChanges()"
        [(ngModel)]="saveCard"><span>{{'Securely save details for future orders' | translate}}</span>
      </checkbox>
    </div>
  }
</div>
<div class="braintree-3ds-container"
  [ngClass]="{'p-t-2 p-b-2' : threeDSInProgress}"
#threedscontainer></div>
@if (scriptStatus.error) {
  <span class="col-2"
  >{{scriptStatus.error}}</span>
}
